import { Button, Box } from "@chakra-ui/react";
import { useCriarManifestacao } from "../contexts/CriarManifestacaoProvider";

export function CriarManifestacaoButton() {
  const { isCreating, setIsCreating } = useCriarManifestacao();

  return (
    <Box opacity={isCreating ? 0.7 : 1} className="leaflet-control leaflet-bar">
      <Button
        variant={!isCreating ? "main" : "solid"}
        onClick={() => setIsCreating(!isCreating)}
      >
        {!isCreating ? "Criar manifestação" : "Cancelar criação"}
      </Button>
    </Box>
  );
}
